import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { useRef, useState } from "react";
import Cards from "react-credit-cards";
import "react-credit-cards/lib/styles.scss";
import { useNegotiation } from "../contexts/NegotiationContext";
import { usePrivate } from "../contexts/PrivateInfoContext";

function BandeiraCartaoDialog({ close, selecionarBandeira }) {
  const { cartaoNumero, setCartaoNumero } = useNegotiation();
  const { cartaoBandeira, setCartaoBandeira } = usePrivate();
  const [cartaoNome] = useState("");
  const [cartaoVencimento] = useState("");
  const [campoFoco] = useState("");
  const cardRef = useRef();

  const bandeiras = [
    {
      value: "mastercard",
      label: "MasterCard",
    },
    {
      value: "elo",
      label: "Elo",
    },
    {
      value: "visa",
      label: "VISA",
    },
    {
      value: "dinersclub",
      label: "Diners Club",
    },
    {
      value: "discover",
      label: "Discover",
    },
    {
      value: "hipercard",
      label: "Hipercard",
    },
    {
      value: "jcb",
      label: "JCB",
    },
    {
      value: "amex",
      label: "American Express",
    },
  ];

  const defineBandeira = (cardData) => {
    cardData.preventDefault();
    console.log(cardData);
    selecionarBandeira();
  };

  console.log(cardRef);

  return (
    <Dialog
      visible
      header="Bandeira do Cartão"
      onHide={() => close()}
      style={{
        minHeigth: "30vw",
        minWidth: "20vw",
        textAlign: "center",
        borderRadius: "0.75rem",
      }}
      draggable={false}
      className="boletosDialog"
    >
      <div className="grid p-1 text-left">
        <div>
          <Cards
            ref={cardRef}
            cvc={""}
            issuer={cartaoBandeira}
            //acceptedCards={['visa','mastercard','elo']}
            callback={(type) => {
              cartaoNumero && setCartaoBandeira(type.issuer);
            }}
            expiry={cartaoVencimento}
            name={cartaoNome}
            number={cartaoNumero}
            focused={campoFoco}
            placeholders={{ name: "NOME" }}
            locale={{ valid: "Válido até" }}
          />
        </div>
        <form onSubmit={(e) => defineBandeira(e)}>
          <div className="flex flex-col mt-4 font-bold gap-2">
            <div className="flex flex-col">
              <label>Selecione a bandeira do Cartão</label>
              <Dropdown
                value={cartaoBandeira}
                options={bandeiras}
                emptyMessage="Bandeira não aceita no momento"
                required
                onChange={(e) => {
                  setCartaoNumero("");
                  setCartaoBandeira(e.value);
                }}
              />
            </div>
            {/* <div className="text-center">
                    <h5>OU</h5>
                </div>
                <div className="flex flex-col">
                    <label>Digite o número do Cartão</label>
                    <InputText
                    name="number"
                    value={cartaoNumero}
                    onChange={e=>{setCartaoNumero(
                        mask(unMask(e.target.value),['9999 999999 9999','9999 999999 99999',
                        '9999 9999 9999 9999']))}}
                    placeholder="ex: 9999 9999 9999 9999"
                    onFocus={e=>{setCampoFoco(e.target.name)}}
                    />
                </div> */}
            <div className="continueButton mt-4">
              <Button label="Escolher" type="submit" />
            </div>
          </div>
        </form>
      </div>
    </Dialog>
  );
}

export default BandeiraCartaoDialog;
